// Last user activity, shared by every portal tab through localStorage so an idle tab
// doesn't log out a session that's in use in another one. The storage event only fires
// in the *other* tabs, which is exactly who needs to hear about it.

const ACTIVITY_KEY = 'af_last_activity';
const PING_KEY = 'af_last_ping';
// Typing fires a write per keystroke otherwise - a few seconds of precision is plenty
// for a minutes-long timeout.
const WRITE_THROTTLE_MS = 5 * 1000;

let lastActivity = Date.now();
let lastWrite = 0;

function readNumber(key) {
  try {
    return Number(localStorage.getItem(key)) || 0;
  } catch {
    return 0;
  }
}

function writeNumber(key, value) {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    // Storage unavailable (private mode, quota) - this tab just tracks on its own.
  }
}

// Returns true when the shared timestamp was actually updated (i.e. not throttled).
export function markActivity({ force = false } = {}) {
  const now = Date.now();
  lastActivity = now;
  if (!force && now - lastWrite < WRITE_THROTTLE_MS) return false;
  lastWrite = now;
  writeNumber(ACTIVITY_KEY, now);
  return true;
}

// Latest activity in any tab.
export function getLastActivity() {
  return Math.max(lastActivity, readNumber(ACTIVITY_KEY));
}

// Calls onActivity whenever another tab records activity. Returns an unsubscribe function.
export function onOtherTabActivity(onActivity) {
  const handler = (e) => { if (e.key === ACTIVITY_KEY) onActivity(); };
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}

// Heartbeat bookkeeping, shared so several open tabs don't each ping the server.
export function getLastPing() {
  return readNumber(PING_KEY);
}

export function markPing() {
  writeNumber(PING_KEY, Date.now());
}
